/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {initiateCryptocurrencyTransfer} from '../api'

export const useMutationInitiateCryptocurrencyTransfer = createReactQueryMutationHook('initiateCryptocurrencyTransfer', initiateCryptocurrencyTransfer)
